import React, { useState, useEffect, useRef } from 'react';
import { Card, Justify, PagingQuery } from 'tea-component';
import { useIntl, useSelector, getLocale, history } from 'umi';
import useUpcomingModel, { FetchParamsType } from '../../hooks/useUpcomingModel';
import Filter from '@/pages/intelligence/pages/TopCharts/components/CommonFilter';
import {
  TableSelectStatusType,
  TableSelectionType,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import ExportTable from '../../../../components/ExportTable';
import Loading from '@/pages/intelligence/components/Loading';
// import Visualis from '@/pages/intelligence/pages/Potential/components/Visualis/UpcomingVisualis';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import SearchRecent from '@/pages/intelligence/components/SearchRecent';
import UpcomingGamesTable from '../../components/Tables/UpcomingGamesTable';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import {
  fetchTopChartsMobileUP,
  fetchTopChartsPCConsoleUP,
} from '@/pages/intelligence/services/topcharts';
import Visualis from '@/pages/intelligence/pages/Potential/components/Visualis/NewReleaseVisualis';
import useNewReleaseBarCharts from '@/pages/intelligence/pages/Potential/hooks/useNewReleaseBarCharts';
import { getFilterName, getFilterValueStorage } from '@/pages/intelligence/components/Filter/util';
import ArrowdownText from '@/pages/intelligence/components/ArrowdownText';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import { tranFormSenorTowerTagParam } from '@/pages/intelligence/utils/topchartsUtils';
import { getDbiFilterParams } from '@intelligence/utils/filterUtils';
import { getValidTopSelectGame } from '@intelligence/utils/topchartsUtils';
import {
  SEGMENT_CHART_SOURCE,
  SEGMENT_CHART_ICONMETRICS,
} from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import {
  updateShortLinkPath,
  ShortLinkQueryType,
  URL_SHORT_LINK_NAME,
  URL_CHART_METRIC,
  URL_SORT_NAME,
  URL_ORDER,
  // URL_SOURCE_NAME,
  URL_RATIO_TYPE,
} from '@intelligence/utils/urlPathCfg';
import {
  START_RELEASE_TIME,
  END_RELEASE_TIME,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { potential } from '@intelligence/v3/constants/downloadLogPoint';
import { buildTopChartsTagClickHandler } from '@intelligence/v3/utils/sensorTowerTagColumns';
import useMobileTopChartsTagDetails from '@intelligence/v3/pages/TopCharts/MobileGames/_hooks/useMobileTopChartsTagDetails';

const UPCOMING = 'upcoming';
interface UpcomingProps {
  entityType: string;
  downloadFileName: string;
  filterCfg: any;
  releaseTimeComponentDefault?: any;
  getDeliveryTipValue: string;
  filterLoading: boolean;
  rangeTimeComponentDefault: any;
  pageLogInfo: any;
  // 页面操作的有效配置
  shortLinkValidQuery: ShortLinkQueryType;
  // 从短链接通过接口获取的url筛选器
  shortLinkFilterValue: any;
  topchartsNameParams?: any;
  // url链接的其他参数组装成的参数
  urlCustomParams: object;
  // 是否开启默认自动勾选
  enableDefaultCheck?: boolean;
  stickyHeaderTitle?: React.ReactNode;
  pageId?: string;
}
export default function Upcoming(props: UpcomingProps) {
  const {
    entityType,
    pageLogInfo,
    downloadFileName,
    filterLoading,
    filterCfg,
    releaseTimeComponentDefault,
    shortLinkValidQuery,
    shortLinkFilterValue,
    urlCustomParams,
    topchartsNameParams,
    enableDefaultCheck,
    stickyHeaderTitle,
    pageId,
  } = props;

  const [tableLoading, setTableLoading] = useState(true);
  const [isVisualisLoading, setIsVisualisLoading] = useState(true);
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return {
      userInfo,
    };
  });
  const { query } = history.location || {};
  // 在筛选器这里拿到缓存的值，并渲染
  const filterSaveName = getFilterName(userInfo);
  const filterSaveData = getFilterValueStorage(userInfo);
  // Upcoming 只使用自己的继承分区，避免被其他 Mobile tab 的时间值污染。
  const { filterExtend, setFilterExtend, isOperate } = useFilterExtend({ pageId });
  const DEFAULT_FORM_VALUE = filterCfg?.defaultValue;
  const [filterValue, setFilterVale] = useState(isOperate ? filterExtend : DEFAULT_FORM_VALUE);
  const filterRef = useRef<any>(null);
  const segmentChartList = SEGMENT_CHART_SOURCE[entityType + UPCOMING];
  const segmentChartIconList = SEGMENT_CHART_ICONMETRICS[entityType + UPCOMING];

  const isHasSegmentChart = !!(segmentChartList && Array.isArray(segmentChartList));
  const isHasSegmentChartIcon = !!(segmentChartIconList && Array.isArray(segmentChartIconList));

  const segmentListDatas = isHasSegmentChart
    ? segmentChartList
    : isHasSegmentChartIcon
    ? segmentChartIconList
    : [];

  const {
    // tableLoading,
    // isVisualisLoading,
    tableData,
    tableTotal,
    barOrPieData,
    setBarOrPieData,
    fetchParams,
    getGameData,
    tableSelection,
    defaultSelectionGames,
    operatedGame,
    setOperatedGame,
    isNodata,
    setTableSelection,
    handleClearSearch,
    transTableDataForSearch,
  } = useUpcomingModel({
    entityType,
    shortLinkValidQuery,
    filterValue,
    setFilterVale,
    hasUrlShortLink: filterCfg?.hasUrlShortLink,
    defaultSelectGameNum: getValidTopSelectGame(query?.topSelect),
    enableDefaultCheck,
  });

  const { gameDetailsLoading, gameDetailsMapping } = useMobileTopChartsTagDetails(
    tableData,
    { enabled: entityType === 'mobile' },
  );

  // 是否重新操作过复选器提交
  // const [isNewComfirm, setIsNewComfirm] = useState(true);
  // 是否重新勾选过游戏
  // const [isNewCheckGame, setIsNewCheckGame] = useState(true);
  const [segmention, setSegmention] = useState(
    segmentListDatas?.length > 0 ? segmentListDatas[0].value : 'Metrics',
  );
  const [sortByName, setSortByName] = useState(
    entityType == 'console'
      ? 'dbi_release_date'
      : segmentListDatas?.length > 0
      ? segmentListDatas[0].text
      : 'dbi_upcoming',
  );
  const [titleNow, setTitleNow] = useState(
    segmentListDatas?.length > 0 ? segmentListDatas[0].text : 'dbi_upcoming',
  );

  // echarts图表类型
  const [chartType] = useState<ChartType>(ChartType.Bar);

  const getData = (args: {
    params: FetchParamsType;
    isCheckGame: boolean;
    isSearch?: boolean;
    isUpdateLineChart?: boolean;
    updateFilterValues?: any;
    myFilterValue?: string;
  }) => {
    const {
      params,
      isCheckGame,
      isSearch = false,
      isUpdateLineChart = false,
      updateFilterValues = filterValue,
      myFilterValue = filterSaveName,
    } = args;

    getGameData({
      params: {
        ...params,
        game_code: isSearch ? params?.game_code : [],
        topcharts_name: topchartsNameParams,
      },
      isCheckOrSearch: isCheckGame,
      isUpdateLineChart,
      updateFilterValues,
      filterSaveName: myFilterValue,
    })
      .then(() => {
        setTableLoading(false);
        setIsVisualisLoading(false);
        // setIsNewComfirm(true);
      })
      .catch(() => {
        setTableLoading(false);
        setIsVisualisLoading(false);
      });
  };

  useEffect(() => {
    setTableLoading(true);
    setIsVisualisLoading(true);
    if (!userInfo?.userid || filterLoading) {
      // 拿缓存值需要拿到用户id
      return;
    }
    let newFetchParams = { ...fetchParams };
    const hasUrlShortLinkVal = query?.[URL_SHORT_LINK_NAME];

    const { filterValue: newFilterValues, filterParams } = getDbiFilterParams({
      userInfo,
      urlCustomParams,
      urlShortLinkFilter: shortLinkFilterValue,
      filterSaveData: filterSaveData?.apiValue,
      filterExtend,
      specialParams: filterCfg?.specialParams,
      isOperate,
      filterName: filterSaveName,
      filterKeyList: filterCfg?.filterKeyList ?? Object.keys(DEFAULT_FORM_VALUE),
    });

    let newFilterValuesTemp = newFilterValues;
    // 如果有短链接，设置为继承模式
    // 若start_release_time，end_release_time为空，接口会报错，故在此处添加兜底，用默认值
    if (
      Array.isArray(newFilterValuesTemp?.releaseTime?.value) &&
      newFilterValuesTemp?.releaseTime?.value[0] == ''
    ) {
      newFilterValuesTemp = {
        ...newFilterValuesTemp,
        releaseTime: {
          ...newFilterValuesTemp.releaseTime,
          value: [START_RELEASE_TIME, END_RELEASE_TIME],
        },
      };
    }

    if (isOperate || hasUrlShortLinkVal) {
      // 如果目前是继承模式，就设置继承值为过滤后的筛选器值
      setFilterExtend(newFilterValuesTemp);
    }
    setFilterVale(newFilterValuesTemp);
    newFetchParams = {
      ...newFetchParams,
      ...(urlCustomParams || {}),
      ...filterCfg?.handleFilterToApiParams?.(filterParams),
    };
    getData({
      params: newFetchParams,
      isCheckGame: operatedGame,
      isSearch: false,
      isUpdateLineChart: true,
      updateFilterValues: newFilterValuesTemp,
    });
  }, [userInfo?.userid, filterLoading, shortLinkFilterValue]);

  useEffect(() => {
    if (shortLinkValidQuery) {
      //   if (shortLinkValidQuery[URL_CHART_TYPE] !== undefined) {
      //     setChartType(shortLinkValidQuery?.[URL_CHART_TYPE]);
      //   }
      if (shortLinkValidQuery[URL_CHART_METRIC] !== undefined) {
        setSegmention(shortLinkValidQuery[URL_CHART_METRIC]);
      }
      if (shortLinkValidQuery[URL_SORT_NAME] !== undefined) {
        setSortByName(shortLinkValidQuery[URL_SORT_NAME]);
      }
    }
  }, [shortLinkValidQuery]);

  useEffect(() => {
    if (!filterLoading && filterCfg?.hasUrlShortLink) {
      let shortObj = {
        [URL_SORT_NAME]: fetchParams.order_metric,
        [URL_ORDER]: fetchParams.order,
        [URL_RATIO_TYPE]: fetchParams.ratio_type,
      } as any;
      if (entityType !== 'mobile') {
        shortObj = {
          ...shortObj,
          [URL_CHART_METRIC]: segmention,
        };
      }
      // TODO找到它对应的文本， 修改它的名字
      updateShortLinkPath({
        shortLinkQuery: shortObj,
      });
    }
  }, [
    filterLoading,
    segmention,
    chartType,
    fetchParams.ratio_type,
    fetchParams.order_metric,
    fetchParams.order,
  ]);

  const onTableSortChage = (e: SortByItemType) => {
    const newFetchParams: FetchParamsType = {
      ...fetchParams,
      order: e?.sortVal,
      order_metric: e?.sortMetric || '',
      ratio_type: e?.ratioType || 0,
      page: 1,
      // page_size: 100,
      page_size: 50,
    };
    setSortByName(e.title);
    setTableLoading(true);
    if (!operatedGame) {
      /** 没有勾选时点排序则重新Loading柱状图数据 */
      setIsVisualisLoading(true);
    }
    getData({
      params: newFetchParams,
      isCheckGame: operatedGame,
      isSearch: false,
      isUpdateLineChart: !operatedGame,
    });
  };

  const onTablePagingChange = (e: PagingQuery) => {
    const newFetchParams: FetchParamsType = {
      ...fetchParams,
      page: e?.pageIndex || 1,
      // page_size: e?.pageSize || 100,
      page_size: e?.pageSize || 50,
    };
    setTableLoading(true);
    getData({
      params: newFetchParams,
      isCheckGame: operatedGame,
      isSearch: false,
      isUpdateLineChart: false,
    });
  };

  // 表格列表项选择事件回调
  const onTableCheckGame = (
    selectList: TableSelectionType[],
    checkStatus: TableSelectStatusType,
  ) => {
    // setIsNewComfirm(true);
    // setIsNewCheckGame(true);

    /** 是否勾选了游戏 */
    if (checkStatus === 'cancel' || checkStatus === 'all' || selectList.length === 0) {
      setOperatedGame(false);
    } else {
      setOperatedGame(true);
      /** 处理游戏继承 */
      // TODO
    }
    /** 将表格数据转换为柱状或饼 */
    setBarOrPieData(selectList);
    setTableSelection(selectList);
  };

  // 柱状图相关hooks
  const { seriesData: barSeriesData, barNameList } = useNewReleaseBarCharts(
    barOrPieData,
    segmention,
  );

  const handleConfirm = (value: any, filter, myFilterValue) => {
    // console.log('handleConfirm-value', value);
    // console.log('handleConfirm-filter', filter);
    // console.log('handleConfirm-myFilterValue', myFilterValue);
    const newFormValue = {
      ...fetchParams,
      ...value,
      page: 1,
      // page_size: 100,
      page_size: 50,
      // markets: formatRegionParams(value?.markets),
    };
    newFormValue.start_release_time = value?.start_release_time || fetchParams?.start_release_time;
    newFormValue.end_release_time = value?.end_release_time || fetchParams?.end_release_time;
    // 请求接口
    setTableLoading(true);
    setIsVisualisLoading(true);
    getData({
      params: newFormValue,
      isCheckGame: false,
      isSearch: false,
      isUpdateLineChart: true,
      updateFilterValues: filter,
      myFilterValue,
    });
    /** 修改筛选器后，游戏应该重置为未勾选状态 */
    setOperatedGame(false);
  };

  const getTableSearchList = (id: string) => {
    setTableLoading(true);
    getData({
      params: { ...fetchParams, game_code: [id] },
      isCheckGame: true,
      isSearch: true,
      isUpdateLineChart: false,
    });
  };

  const fetchTopChartsUPEnhancer = (fetcher: Function) => {
    return (params: any) => {
      return fetcher({ ...params, entity_type: entityType });
    };
  };

  const handleReset = () => {};

  const handleTagClick = buildTopChartsTagClickHandler({
    filterRef,
    filterValue,
    setFilterValue: setFilterVale,
    sensorTowerTagConfig: filterCfg?.specialParams?.sensorTowerTagConfig,
  });

  return (
    <div className={entityType === 'mobile' ? 'dbi-potential-upcoming-page' : ''}>
      <Card>
        <Card.Body>
          <Filter
            ref={filterRef}
            filterConfirm={handleConfirm}
            filterReset={handleReset}
            extendPageId={pageId}
            filterValue={filterValue}
            setFilterVale={setFilterVale}
            defaultValue={DEFAULT_FORM_VALUE}
            filterCfg={{ ...filterCfg, stickyHeaderTitle }}
            releaseTimeComponentDefault={releaseTimeComponentDefault}
            buriedPointParams={pageLogInfo}
          />
        </Card.Body>
      </Card>
      {entityType !== 'mobile' && (
        <>
          <Card className="dbi-mobileGames-card-context">
            <Card.Body
              title={
                <div style={{ display: 'flex' }}>
                  <span style={{ marginRight: 10 }}>{formatMessage({ id: `dbi_upcoming` })}</span>
                  <ArrowdownText
                    isNew={true}
                    sortedData={formatMessage({ id: sortByName })}
                    order={fetchParams.order}
                  />
                </div>
              }
            >
              {isVisualisLoading ? (
                <div style={{ height: 358 }}>
                  <Loading />
                </div>
              ) : (
                <Visualis
                  fetchParams={fetchParams}
                  chartType={chartType}
                  barOrPieData={barOrPieData}
                  barSeriesData={barSeriesData}
                  barNameList={barNameList}
                  imageType={entityType}
                  topChartsType={UPCOMING}
                  isNodata={isNodata}
                  setSegmention={setSegmention}
                  segmention={segmention}
                  titleNow={formatMessage({ id: titleNow })}
                  setTitleNow={setTitleNow}
                  isHasSegmentChart={isHasSegmentChart}
                  isHasSegmentChartIcon={isHasSegmentChartIcon}
                  tableSelection={tableSelection}
                  sortByName={formatMessage({ id: sortByName })}
                  segmentListDatas={segmentListDatas}
                />
              )}
            </Card.Body>
          </Card>
        </>
      )}
      <Justify
        className="dbi-card-justify"
        right={
          <>
            <SearchRecent
              fetchParams={
                entityType === 'mobile'
                  ? tranFormSenorTowerTagParam({ ...fetchParams, page: 1, filter_ids: [] })
                  : { ...fetchParams, page: 1, filter_ids: [] }
              }
              handleClear={handleClearSearch}
              getTableResultList={getTableSearchList}
              searchListApi={
                fetchTopChartsUPEnhancer(entityType === 'mobile' ? fetchTopChartsMobileUP : fetchTopChartsPCConsoleUP)
              }
              pageLogInfo={pageLogInfo}
              searchType={`${entityType}_upcoming`}
              initSearchInput={!(fetchParams?.game_code?.length > 0)}
              transTableDataForSearch={transTableDataForSearch}
            />
            <ExportTable
              entityType={entityType}
              businessType={`${entityType}-upcoming`}
              classModalName="dbi-download-type-one"
              isDisableDownload={tableLoading}
              tableParams={{ ...fetchParams, select_ids: tableSelection }}
              isNeedCheckedLines={true}
              defaultCheckedLines={operatedGame}
              isGameTopCharts={true}
              downloadModalSize={locale === LANGUAGE_CN ? 542 : 650}
              total={tableTotal}
              newStyleFileName={downloadFileName}
              downloadLogConfigKey={potential?.[`${entityType}_upcoming`]}
            />
          </>
        }
      />
      <CardSlot>
        <UpcomingGamesTable
          className="dbi-mobileGames-table dbi-table-sticky"
          entityType={entityType}
          records={tableData}
          loading={tableLoading}
          tableTotal={tableTotal}
          pageSortAttr={{
            tablePageIndex: fetchParams.page,
            tablePageSize: fetchParams.page_size,
            currentSortValue: fetchParams.order,
            currentSortMetric: `${fetchParams.order_metric}_${fetchParams.ratio_type}`,
          }}
          onTableSortChage={onTableSortChage}
          onTablePagingChange={onTablePagingChange}
          onTableCheckGame={onTableCheckGame}
          tableSelection={tableSelection}
          tableSelectionAll={defaultSelectionGames}
          releaseTime={{
            startRelease: fetchParams?.start_release_time,
            endRelease: fetchParams?.end_release_time,
          }}
          filterValue={filterValue}
          gameDetailsLoading={gameDetailsLoading}
          gameDetailsMapping={gameDetailsMapping}
          onTagClick={handleTagClick}
        />
      </CardSlot>
    </div>
  );
}
